var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{attrs:{"color":"transparent"}},[(_vm.isPlatformUser)?[(_vm.canView)?_c('platform-home'):_vm._e()]:[_c('enterprise-home')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }